var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBubbleAddFill = function SvgChatBubbleAddFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 18-2.3 2.3q-.476.475-1.088.212Q2 20.25 2 19.575V4q0-.824.587-1.413A1.93 1.93 0 0 1 4 2h10.1a5.1 5.1 0 0 0 0 2q.35 1.725 1.725 2.862A4.84 4.84 0 0 0 19 8q.8 0 1.575-.25A4.7 4.7 0 0 0 22 7v9q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h1v1q0 .424.288.713Q18.575 6 19 6q.424 0 .712-.287A.97.97 0 0 0 20 5V4h1q.424 0 .712-.288A.97.97 0 0 0 22 3a.97.97 0 0 0-.288-.712A.97.97 0 0 0 21 2h-1V1a.97.97 0 0 0-.288-.712A.97.97 0 0 0 19 0a.97.97 0 0 0-.712.288A.97.97 0 0 0 18 1v1h-1a.97.97 0 0 0-.712.288A.97.97 0 0 0 16 3q0 .424.288.712Q16.575 4 17 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubbleAddFill);
export { ForwardRef as ReactComponent };